function IframeVideos() {
	this.build();
}

IframeVideos.prototype.build = function () {
	$('.editor-text').fitVids();
};
